import Indicador from ".."
import BioEditFields from "./components/BioEditFields"
// import BioGraficoPainel from "./components/BioGraficoPainel"
// import BioGraficoRelatorio from "./components/BioGraficoRelatorio"
import { BioParamFields } from "./components/BioParamFields"
import bioReport from "./reports"
import bioReportSummary from "./reports/summary"

export default class Bio extends Indicador {
    static get fullName() {
        return "Biometria"
    }

    static get abbrev() {
        return "Bio"
    }

    static paramFields(tipoIndicadorField = '') {
        return <BioParamFields tipoIndicadorField={tipoIndicadorField} />
    }

    static getEditFields(visita, isNew, TipoClass) {
        return <BioEditFields visita={visita} TipoClass={TipoClass} />
    }

    // static getGraficoPainel(mediaAgrupadorList, fullName, nomeAgrupador, meta) {
    //     return <BioGraficoPainel media={mediaAgrupadorList[0].media} fullName={fullName} nomeAgrupador={nomeAgrupador} />
    // }

    // static getGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro) {
    //     return BioGraficoRelatorio(h, mediaAgrupadorList, metaUsar, titulo, groupByConfig, apontamentos, paramsCliente, dataInicio, dataFim, primeiro)
    // }

    async renderReport(visita) {
        return bioReport(this, visita)
    }

    async renderReportSummary(visita, tipoName) {
        return bioReportSummary(this, visita, tipoName)
    }

    static calcConformidade(apontamento, params) {
        const f = parseFloat

        if (!apontamento.coletas || !params || apontamento.coletas.length === 0) {
            return 0
        }

        let pesoTotal = 0, canasAvaliadasTotal = 0, metrosAvaliadosTotal = 0, perfilhosTotal = 0, calculo = 0, media = 0, metroLinearTotal = 0, total = apontamento.coletas.length

        for (const coleta of apontamento.coletas) {
            if (coleta.peso && coleta.perfilhos) {
                pesoTotal += f(coleta.peso)
                perfilhosTotal += f(coleta.perfilhos)
            } else {
                total--
            }
        }
        canasAvaliadasTotal = (f(params.canasAvaliadas) * total)
        metrosAvaliadosTotal = (f(params.metrosAvaliados) * total)
        metroLinearTotal = (f(params.metroLinear) * total)

        calculo = ((pesoTotal / canasAvaliadasTotal) * (perfilhosTotal / metrosAvaliadosTotal) * metroLinearTotal)
        media = (calculo / total).toFixed(2)

        // console.log(`((${pesoTotal} / ${canasAvaliadasTotal}) * (${perfilhosTotal} / ${metrosAvaliadosTotal}) * ${metroLinearTotal}) / ${total} = ${media}`)

        return media
    }

    static getConformidadeStatus(conformidade, meta) {
        // return this.calcConformidadeStatus(conformidade, meta, 88.89, 100, 105.55)
        return ''
    }

    static calcPontosAmostrados(apontamento, paramItems) {
        const result = []

        for (const item of paramItems) {
            let count = 0

            for (const coleta of apontamento.coletas) {
                if (this.calcPontoAmostradoColeta(item, coleta.qtdGemas)) {
                    count++
                }
            }

            result.push({
                ...item,
                count: count,
            })
        }

        return result
    }

    static getTableRelApontamentos(paramsCliente, IndicadorClass) {
        return [
            { title: "Data", width: 'auto', getValue: (a) => a.dataRef.split("-").reverse().join('/') },
            { title: "Laudo", field: "laudoRef.sequencialIndex", width: 28 },
            { title: "Cod.", field: "laudoRef.fazenda.codFazenda", width: 'auto' },
            { title: "Faz.", field: "laudoRef.fazenda.nomeFazenda" },

            { title: "Talhão", field: "talhao.nome" },

            { title: "Variedade", field: "insumo", width: 'auto' },

            {
                title: "Peso", width: 'auto', getValue: (a) => {
                    let sum = 0
                    a.coletas.forEach(x => {
                        if (x.peso) sum = sum + parseFloat(x.peso)
                    })
                    if (sum) return sum
                    else return '0'
                }
            },

            {
                title: "Perfilhos", width: 'auto', getValue: (a) => {
                    let sum = 0
                    a.coletas.forEach(x => {
                        if (x.perfilhos) sum = sum + parseFloat(x.perfilhos)
                    })
                    if (sum) return sum
                    else return '0'
                }
            },

            { title: "Resultado", field: "conformidade", width: "auto", getColor: a => IndicadorClass.getColorStatus(IndicadorClass.getConformidadeStatus(a.conformidade, paramsCliente?.meta)) },
        ]
    }

    static getResultStr(apontamento) {
        let sumPeso = 0
        let sumPerfilhos = 0

        apontamento.coletas.forEach(x => {
            if (x.peso)
                sumPeso = sumPeso + parseFloat(x.peso)
            if (x.peso)
                sumPerfilhos = sumPerfilhos + parseFloat(x.perfilhos)
        })

        return "Peso: " + sumPeso + ", Perfilhos: " + sumPerfilhos
    }
}
